module.exports = __webpack_public_path__ + "img/Flag_of_Belize (1).447d508b.svg";